import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
	BespokeCube123_01: 'BespokeCube12301_BookShelf',
	BespokeCube123_02: 'BespokeCube123_02_DeskShelf',
	BespokeCube123_03: 'BespokeCube123_03_Storagebox',
	BespokeCube123_04: 'BespokeCube123_04_Magazinerack',
	BespokeCube123_05: 'BespokeCube123_05_Seaturtle',
	BespokeCube123_06: 'BespokeCube123_06_Toolbox',
	BespokeCube123_07: 'BespokeCube123_07_WineRack',
	BespokeCube123_08: 'BespokeCube123_08_WineRackDog',
	BespokeCube123_09: 'BespokeCube123_09_PetFurniture',
	BespokeCube123_10: 'BespokeCube123_10_ShoeRackA',
};

export default {
	categoryKey: CategoryLists.Airpurifier.list.BespokeCube123,
	cover: {
		caption: 'LandingPage.BespokeCube123',
		backgroundImage: require('../../cover_image/cover_animals.jpg'),
		mobileCoverImage: require('../../cover_image/cover_animals.jpg'),
		mainImage: {
			src: require('../../../assets/categories/bespoke_cubeAir123.png'),
			pcSrc: require('../../../assets/categories/bespoke_cubeAir123.png'),
		},
	},
	box: {
		title: 'ProductPage.selectDesign', //i18n
		list: [
			{
				key: ModelKey.BespokeCube123_07,
				image: {
					mobile: require('../../thumbnail/winerack.png'),
					pc: require('../../thumbnail/winerack.png'),
				},
				title: 'ProductPage.WineRack', // i18n
				level: 2,
				minutes: 50,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_01,
				image: {
					mobile: require('../../thumbnail/Book_shelf.png'),
					pc: require('../../thumbnail/Book_shelf.png'),
				},
				title: 'ProductPage.BookShelf', // i18n
				level: 2,
				minutes: 60,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_10,
				image: {
					mobile: require('../../thumbnail/shoerackA.png'),
					pc: require('../../thumbnail/shoerackA.png'),
				},
				title: 'ProductPage.ShoeRackA', // i18n
				level: 3,
				minutes: 60,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_02,
				image: {
					mobile: require('../../thumbnail/Desk_shelf.png'),
					pc: require('../../thumbnail/Desk_shelf.png'),
				},
				title: 'ProductPage.DeskShelf', // i18n
				level: 3,
				minutes: 80,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_03,
				image: {
					mobile: require('../../thumbnail/Storagebox.png'),
					pc: require('../../thumbnail/Storagebox.png'),
				},
				title: 'ProductPage.StorageBox', // i18n
				level: 3,
				minutes: 120,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_04,
				image: {
					mobile: require('../../thumbnail/Magazine_rack.png'),
					pc: require('../../thumbnail/Magazine_rack.png'),
				},
				title: 'ProductPage.MagazineRack', // i18n
				level: 4,
				minutes: 150,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_08,
				image: {
					mobile: require('../../thumbnail/winerackdog.png'),
					pc: require('../../thumbnail/winerackdog.png'),
				},
				title: 'ProductPage.WineRackDog', // i18n
				level: 4,
				minutes: 150,
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_09,
				image: {
					mobile: require('../../thumbnail/petfurniture.png'),
					pc: require('../../thumbnail/petfurniture.png'),
				},
				title: 'ProductPage.PetFurniture', // i18n
				level: 5,
				minutes: 180,
				allowInches: [],
			},
		],
	},
	dezeenBox: {
		title: 'ProductPage.selectDesignDezeen', //i18n
		list:[
			{
				key: ModelKey.BespokeCube123_05,
				image: {
				mobile: require('../../thumbnail/Endangered_Animals_turtle.png'),
				pc: require('../../thumbnail/Endangered_Animals_turtle.png'),
			},
				title: 'ProductPage.SeaTurtle', // i18n
				allowInches: [],
			},
			{
				key: ModelKey.BespokeCube123_06,
				image: {
				mobile: require('../../thumbnail/Toolbox.png'),
				pc: require('../../thumbnail/Toolbox.png'),
				},
				title: 'ProductPage.ToolBox', // i18n
				allowInches: [],
			},
		]
	},
	worldcup:{},
	disney:{},
	ModelKey: ModelKey,
};

export const Boxes = {
	[ModelKey.BespokeCube123_01]: () => import('./bookshelf'),
	[ModelKey.BespokeCube123_02]: () => import('./deskshelf'),
	[ModelKey.BespokeCube123_03]: () => import('./storagebox'),
	[ModelKey.BespokeCube123_04]: () => import('./magazinerack'),
	[ModelKey.BespokeCube123_05]: () => import('./turtle'),
	[ModelKey.BespokeCube123_06]: () => import('./toolbox'),
	[ModelKey.BespokeCube123_07]: () => import('./winerack'),
	[ModelKey.BespokeCube123_08]: () => import('./winerackdog'),
	[ModelKey.BespokeCube123_09]: () => import('./petfurniture'),
	[ModelKey.BespokeCube123_10]: () => import('./shoerackA'),
};
